export interface TxMeta {
  label: string;
  /** true = credit (green, +), false = debit (red, -). */
  credit: boolean;
}

/** Italian label + credit/debit direction per WalletTransactionType. */
export const WALLET_TX_META: Record<string, TxMeta> = {
  recharge: { label: 'Ricarica', credit: true },
  consultation_charge: { label: 'Addebito consulenza', credit: false },
  free_minutes_credit: { label: 'Minuti gratuiti', credit: true },
  refund: { label: 'Rimborso', credit: true },
  call_charge: { label: 'Addebito chiamata', credit: false },
  chat_charge: { label: 'Addebito chat', credit: false },
  credit_reservation: { label: 'Prenotazione credito', credit: false },
  reservation_release: { label: 'Rilascio prenotazione', credit: true },
  recharge_bonus: { label: 'Bonus ricarica', credit: true },
  admin_credit: { label: 'Credito omaggio (admin)', credit: true },
  cashback_bonus: { label: 'Cashback', credit: true },
  birthday_bonus: { label: 'Bonus compleanno', credit: true },
  referral_bonus: { label: 'Bonus referral', credit: true },
  bonus_expired: { label: 'Bonus scaduto', credit: false },
};

/** Meta for a type, falling back to the raw type + amount sign. */
export function txMeta(type: string, amount: number): TxMeta {
  return WALLET_TX_META[type] ?? { label: type, credit: amount >= 0 };
}
